import React from 'react';
import { Chart } from "react-google-charts";

export function PieChart({categorisedFootprint, reduceFootprint, colors}) {


    const chartOptions = {
      fontSize: 12,
      backgroundColor: 'transparent',
      chartArea: { width: '100%', left: 10, top: 10, bottom: 10, right: 10 },
      legend: 'none',
      pieSliceText: 'none',
      // pieSliceText: 'label',
      animation: {
        startup: true,
        easing: 'linear',
        duration: 1500
      },
      tooltip: {
        trigger: 'none'
      },
      // slices: {
      //   0: { color: 'yellow' ,pieSliceTextStyle:''},
      //   1: { color: 'transparent' }
      // }
      colors: colors
    };

  // componentWillReceiveProps(nextProps) {
  //   this.setState({ footprint: nextProps.footprint });
  // }

  function pieChartClick(event ) {
    // console.log('click'+JSON.stringify(chartWrapper));
    if(reduceFootprint) reduceFootprint(event.chartWrapper);
  }

  function pieChartReady(  ) {
    // console.log('ready'+chartWrapper);
    // chart = chartWrapper;
  }

  const chartEvents = [
    {
      eventName: "select",
      callback: pieChartClick.bind(this)
    },
    {
      eventName: "ready",
      callback: pieChartReady.bind(this)
    }
  ];

    const initialData = [
      ['Category', 'Proportion']]

    for (var key in categorisedFootprint) {
      if (categorisedFootprint.hasOwnProperty(key)) {
        initialData.push([key, categorisedFootprint[key]]);
      }
    }

    return (
      <>
        <Chart
          chartEvents={chartEvents}
          className="footprintChart"
          height={300}
          chartType="PieChart"
          loader={<div>Loading Chart</div>}
          data={initialData}
          formatters={[
            {
              type: 'PatternFormat',
              column: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              options: '{0} {1}t'
            }
          ]}
          options={chartOptions}
        />
      </>
    );
  }
